import { Box, Grid, List, ListItem } from '@mui/material';
import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ApartmentIcon from '@mui/icons-material/Apartment';
import SettingsIcon from '@mui/icons-material/Settings';
import PolicyIcon from '@mui/icons-material/Policy';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LogoutIcon from '@mui/icons-material/Logout';
import SecurityIcon from '@mui/icons-material/Security';
import MoneyIcon from '@mui/icons-material/Money';
import TuneIcon from '@mui/icons-material/Tune';
import ApiIcon from '@mui/icons-material/Api';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useHistory } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import Logo from './Logo';

const SideBar = ({ setOpen }) => {

  const history = useHistory();
  const { user, logout } = useAuth();
  const userType = user?.userType ?? ""
  
  // Dynamic logo sizing based on current route
  const isDashboard = history.location.pathname.includes('/dashboard');
  const logoHeight = isDashboard ? 80 : 120; // Dashboard: double (80px), Auth pages: triple (120px)
  
  const handleLogout = () => {
    logout()
  };

  return (
    <>
      {/* outer-footerBottom */}
      <Box minHeight={'100vh'} height={'100%'} sx={{ backgroundColor: '#1a1d26', zIndex: 1000 }} padding={2} position={'relative'}>
        <Grid item container>
          <Grid item xs={12} display={{ xs: 'none', lg: 'block' }}>
            <Logo 
              height={logoHeight}
              variant="white"
              sx={{ 
                maxHeight: `${logoHeight}px`
              }}
            />
          </Grid>
          <Grid item xs={12} pt={{xs: '0', lg: 5}} pb={10}>
            <List sx={{ gap: 2, display: 'flex', flexDirection: 'column' }}>
              <ListItem component={'a'}
                onClick={() => { setOpen && setOpen(false); history.push(userType === "superAdmin" ? '/dashboard' : '/company/dashboard') }} sx={{
                  border: history.location.pathname.includes('/dashboard') ? '1px solid #fff' : '1px solid transparent',
                  borderRadius: 2, backgroundColor: history.location.pathname.includes('/dashboard') ? '#1f1d45' : '',
                  color: '#fff',
                  '&:hover': {
                    border: '1px solid #fff',
                    backgroundColor: '#1f1d45',
                  }
                }}>
                <DashboardIcon /> &nbsp; Dashboard
              </ListItem>
              {userType === "superAdmin" &&
                <ListItem component={'a'} onClick={() => { setOpen && setOpen(false); history.push('/companies') }} sx={{
                  border: history.location.pathname.includes('/companies') ? '1px solid #fff' : '1px solid transparent',
                  borderRadius: 2, color: '#fff',
                  backgroundColor: history.location.pathname.includes('/companies') ? '#1f1d45' : '',
                  '&:hover': {
                    border: '1px solid #fff',
                    backgroundColor: '#1f1d45',
                  }
                }}><ApartmentIcon /> &nbsp; Company</ListItem>
              }
              {userType === "company" &&
                <ListItem component={'a'} onClick={() => { setOpen && setOpen(false); history.push('/company/members') }} sx={{
                  border: history.location.pathname.includes('/members') ? '1px solid #fff' : '1px solid transparent',
                  borderRadius: 2, color: '#fff',
                  backgroundColor: history.location.pathname.includes('/members') ? '#1f1d45' : '',
                  '&:hover': {
                    border: '1px solid #fff',
                    backgroundColor: '#1f1d45',
                  }
                }}><ApartmentIcon /> &nbsp; Member</ListItem>
              }
              {userType === "company" &&
                <ListItem component={'a'} onClick={() => { setOpen && setOpen(false); history.push('/company/api-management') }} sx={{
                  border: history.location.pathname.includes('/api-management') || history.location.pathname.includes('/security') ? '1px solid #fff' : '1px solid transparent',
                  borderRadius: 2, color: '#fff',
                  backgroundColor: history.location.pathname.includes('/api-management') || history.location.pathname.includes('/security') ? '#1f1d45' : '',
                  '&:hover': {
                    border: '1px solid #fff',
                    backgroundColor: '#1f1d45',
                  }
                }}><SecurityIcon /> &nbsp; API Security</ListItem>
              }
              {userType === "superAdmin" &&
                <ListItem component={'a'} onClick={() => { setOpen && setOpen(false); history.push('/verification-rules') }} sx={{
                  border: history.location.pathname.includes('/verification-rules') ? '1px solid #fff' : '1px solid transparent',
                  borderRadius: 2, color: '#fff',
                  backgroundColor: history.location.pathname.includes('/verification-rules') ? '#1f1d45' : '',
                  '&:hover': {
                    border: '1px solid #fff',
                    backgroundColor: '#1f1d45',
                  }
                }}><PolicyIcon /> &nbsp; Verification Rules</ListItem>
              }
              {userType === "superAdmin" &&
                <ListItem component={'a'} onClick={() => { setOpen && setOpen(false); history.push('/verification-attempts') }} sx={{
                  border: history.location.pathname.includes('/verification-attempts') ? '1px solid #fff' : '1px solid transparent',
                  borderRadius: 2, color: '#fff',
                  backgroundColor: history.location.pathname.includes('/verification-attempts') ? '#1f1d45' : '',
                  '&:hover': {
                    border: '1px solid #fff',
                    backgroundColor: '#1f1d45',
                  }
                }}><ReceiptLongIcon /> &nbsp; Verification Attempts</ListItem>
              }
              {userType === "company" &&
                <ListItem component={'a'} onClick={() => { setOpen && setOpen(false); history.push('/company/billing') }} sx={{
                  border: history.location.pathname === '/company/billing' ? '1px solid #fff' : '1px solid transparent',
                  borderRadius: 2, color: '#fff',
                  backgroundColor: history.location.pathname === '/company/billing' ? '#1f1d45' : '',
                  '&:hover': {
                    border: '1px solid #fff',
                    backgroundColor: '#1f1d45',
                  }
                }}><MoneyIcon /> &nbsp; Billing</ListItem>
              }
              {userType === "company" &&
                <ListItem component={'a'} onClick={() => { setOpen && setOpen(false); history.push('/company/plan-settings') }} sx={{
                  border: history.location.pathname.includes('/plan-settings') ? '1px solid #fff' : '1px solid transparent',
                  borderRadius: 2, color: '#fff',
                  backgroundColor: history.location.pathname.includes('/plan-settings') ? '#1f1d45' : '',
                  '&:hover': {
                    border: '1px solid #fff',
                    backgroundColor: '#1f1d45',
                  }
                }}><TuneIcon /> &nbsp; Plan Settings</ListItem>
              }
              {userType === "superAdmin" &&
                <ListItem component={'a'} onClick={() => { setOpen && setOpen(false); history.push('/billing') }} sx={{
                  border: history.location.pathname.includes('/billing') ? '1px solid #fff' : '1px solid transparent',
                  borderRadius: 2, color: '#fff',
                  backgroundColor: history.location.pathname.includes('/billing') ? '#1f1d45' : '',
                  '&:hover': {
                    border: '1px solid #fff',
                    backgroundColor: '#1f1d45',
                  }
                }}><MoneyIcon /> &nbsp; Billing</ListItem>
              }
              {userType === "company" &&
                <ListItem component={'a'} onClick={() => { setOpen && setOpen(false); history.push('/company/api-docs') }} sx={{
                  border: history.location.pathname.includes('/api-docs') ? '1px solid #fff' : '1px solid transparent',
                  borderRadius: 2, color: '#fff',
                  backgroundColor: history.location.pathname.includes('/api-docs') ? '#1f1d45' : '',
                  '&:hover': {
                    border: '1px solid #fff',
                    backgroundColor: '#1f1d45',
                  }
                }}><ApiIcon /> &nbsp; API Docs</ListItem>
              }
              {userType === "superAdmin" &&
                <ListItem component={'a'} onClick={() => { setOpen && setOpen(false); history.push('/api-docs') }} sx={{
                  border: history.location.pathname.includes('/api-docs') ? '1px solid #fff' : '1px solid transparent',
                  borderRadius: 2, color: '#fff',
                  backgroundColor: history.location.pathname.includes('/api-docs') ? '#1f1d45' : '',
                  '&:hover': {
                    border: '1px solid #fff',
                    backgroundColor: '#1f1d45',
                  }
                }}><ApiIcon /> &nbsp; API Docs</ListItem>
              }
              <ListItem component={'a'} onClick={() => {
                setOpen && setOpen(false);
                history.push(userType === "superAdmin" ? '/admin/docs' : '/company/docs');
              }} sx={{
                border: history.location.pathname.includes('/docs') && !history.location.pathname.includes('/api-docs') ? '1px solid #fff' : '1px solid transparent',
                borderRadius: 2,
                color: '#fff',
                backgroundColor: history.location.pathname.includes('/docs') && !history.location.pathname.includes('/api-docs') ? '#1f1d45' : '',
                '&:hover': {
                  border: '1px solid #fff',
                  backgroundColor: '#1f1d45',
                }
              }}><HelpOutlineIcon /> &nbsp; Help &amp; Docs</ListItem>
            </List>
          </Grid>
          <Grid item width={'100%'} padding={2} position={'absolute'} bottom={0} left={0} sx={{ zIndex: 10 }}>
            <List sx={{ gap: 2, display: 'flex', flexDirection: 'column' }}>
              <ListItem component={'a'} className={history.location.pathname.includes('/profile') ? 'active' : 'Inactive'}
                onClick={() => { setOpen && setOpen(false); history.push(userType === "superAdmin" ? '/profile' : '/company/profile') }}
                sx={{
                  borderRadius: 2, color: '#fff',
                  '&:hover': {
                    backgroundColor: '#1f1d45',
                  }
                }}><SettingsIcon /> &nbsp; Settings</ListItem>
              <ListItem component={'a'} sx={{
                borderRadius: 2, color: '#fff',
                '&:hover': {
                  backgroundColor: '#1f1d45',
                }
              }} onClick={() => handleLogout()}><LogoutIcon /> &nbsp; Logout</ListItem>
            </List>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};


export default SideBar;
